import { css } from "lit";
import { mediumBreakPoint } from '../utils/css/breakpoints';
import { fastButtonCss } from '../utils/css/fast-elements';

export const appButtonStyles = css`
	:host {
		border-radius: var(--button-radius);
		display: block;
		outline: none;
		--font-size: var(--desktop-button-font-size);
		--button-height: 44px;
		--button-height: var(--desktop-button-height);
		--button-square: var(--button-height);
		--button-width: 127px;
		--button-width: var(--button-width);
		--button-font-color: var(--secondary-color);
		--pading-vertical: 0;
		--padding-horizontal: 34px;
	}

	${fastButtonCss}

	[appearance='lightweight'] {
		box-shadow: none;
	}

	fast-button.link {
		--accent-foreground-active: var(--font-color);
		--accent-foreground-hover: var(--font-color);
		width: auto;
		border-radius: unset;
		box-shadow: none;
		background-color: transparent;
	}

	fast-button.link::part(control) {
		--padding-horizontal: 0;
		width: auto;
	}

	fast-button.round,
	fast-button.square {
		height: var(--button-square);
		width: var(--button-square);
	}

	fast-button.round::part(control),
	fast-button.square::part(control) {
		/* assumption is that the button is 14x21 */
		--padding-horizontal: 15px;
		align-items: center;
		line-height: 0;
	}

	fast-button:focus {
		outline: solid;
		outline-width: 2px;
	}

	${mediumBreakPoint(
		css`
			fast-button.navigation {
				--button-width: 100px;
				--button-height: 40px;
				line-height: 28px;
				font-size: 16px;
			}
		`
	)}
`;
